export const NARROW_PORTRAIT_MEDIA_QUERY = "(max-width:600px) and (orientation: portrait)";